import { BarChartOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Input, Typography } from 'antd';
import { useState } from 'react';
import { useAuth } from '../auth';
import { errorMessage } from '../utils';

interface LoginValues {
  username: string;
  password: string;
}

export function LoginPage() {
  const { login } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = async (values: LoginValues) => {
    setSubmitting(true);
    setError('');
    try {
      await login(values.username, values.password);
    } catch (reason) {
      setError(errorMessage(reason));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-brand">
          <span>
            <BarChartOutlined />
          </span>
          <div>
            <Typography.Title level={2}>星豚产品运营数据平台</Typography.Title>
            <Typography.Text type="secondary">内部管理后台</Typography.Text>
          </div>
        </div>
        {error ? (
          <Alert type="error" showIcon message={error} closable onClose={() => setError('')} />
        ) : null}
        <Form<LoginValues>
          layout="vertical"
          requiredMark={false}
          onFinish={(values) => void submit(values)}
          initialValues={{ username: 'admin' }}
          size="large"
        >
          <Form.Item
            label="账号"
            name="username"
            rules={[{ required: true, message: '请输入账号' }]}
          >
            <Input prefix={<UserOutlined />} autoComplete="username" autoFocus />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 12, message: '密码至少 12 位' },
            ]}
          >
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting} block>
            登录
          </Button>
        </Form>
      </section>
      <footer>星豚智能 · 产品运营中心</footer>
    </main>
  );
}
